import { Grid } from '@material-ui/core';
import { Article } from '../../../../components/article/form/ArticleForm';
import { LayoutConstants } from '../../../../theme/LayoutConstants';
import { useParams } from 'react-router-dom';
import { useArticleQuery } from '../../../../graphql/models';
import { ApiRequestErrorAndLoadingWrapper } from '../../../../components/common/ApiRequestWrapper';
import { FormBreadCrumbs } from '../../../../components/common/navigation/breadcrumbs/FormBreadcrumbs';

export const EditArticlePage = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const numberId = Number(id);

  const { data, error, loading } = useArticleQuery({
    variables: { id: numberId },
  });

  return (
    <ApiRequestErrorAndLoadingWrapper error={error} loading={loading}>
      <Grid container spacing={LayoutConstants.gridSpacing}>
        <Grid item xs={12}>
          <FormBreadCrumbs
            translateLastPathName={data?.article === undefined}
          />
        </Grid>
        <Grid item xs={12}>
          <Article article={data?.article} />
        </Grid>
      </Grid>
    </ApiRequestErrorAndLoadingWrapper>
  );
};
